(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["golfather-filter"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGF(root) {
    if (!root || root.__gfInit) return;
    root.__gfInit = true;

    var prefix    = (root.getAttribute('data-brand-prefix') || 'BRAND_').toUpperCase();
    var resultsTpl = root.getAttribute('data-results-text') || '[count] [files] match your game';
    var idleTpl    = root.getAttribute('data-idle-text') || 'Showing all [count] [files]';

    /* ── Toggle collapse / expand ── */
    var toggleBtn = root.querySelector('[data-toggle]');
    var dimsWrap  = root.querySelector('[data-dims]');
    var toggleCount = root.querySelector('[data-toggle-count]');

    function setExpanded(open) {
      if (!toggleBtn || !dimsWrap) return;
      toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      dimsWrap.classList.toggle('gf-dims--collapsed', !open);
      dimsWrap.classList.toggle('gf-dims--expanded', open);
    }
    function updateToggleCount() {
      if (!toggleCount) return;
      var n = root.querySelectorAll('.gf-folder.is-selected').length;
      toggleCount.textContent = n > 0 ? '(' + n + ' selected)' : '';
    }
    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        var isOpen = toggleBtn.getAttribute('aria-expanded') === 'true';
        setExpanded(!isOpen);
      });
    }
    // Start collapsed
    setExpanded(false);

    var cards   = Array.prototype.slice.call(root.querySelectorAll('.gf-card'));
    var folders = Array.prototype.slice.call(root.querySelectorAll('.gf-folder'));
    var brandSelect = root.querySelector('[data-brand-select]');
    var brandWrap   = root.querySelector('[data-brand-wrap]');
    var countEl = root.querySelector('[data-count]');
    var emptyEl = root.querySelector('[data-empty]');
    var resets  = Array.prototype.slice.call(root.querySelectorAll('[data-reset]'));

    // Pre-parse each card's tags (uppercased for case-insensitive matching)
    cards.forEach(function (c) {
      c.__tags = (c.getAttribute('data-tags') || '').toUpperCase().split(',').filter(Boolean);
      c.__hidden = false;
    });

    var selections = {};   // dimensionId -> Set of selected tags
    var brandValue = '';

    // Build the brand dropdown dynamically from product BRAND_ tags
    if (brandSelect) {
      var seen = {};
      cards.forEach(function (c) {
        var b = c.getAttribute('data-brand');
        if (b && !seen[b.toUpperCase()]) { seen[b.toUpperCase()] = b; }
      });
      var list = Object.keys(seen).map(function (k) { return seen[k]; })
        .sort(function (a, b) { return a.localeCompare(b); });
      list.forEach(function (name) {
        var opt = document.createElement('option');
        opt.value = name; opt.textContent = name;
        brandSelect.appendChild(opt);
      });
      if (list.length === 0 && brandWrap) { brandWrap.hidden = true; }
      brandSelect.addEventListener('change', function () { brandValue = this.value; apply(); });
    }

    folders.forEach(function (f) {
      f.addEventListener('click', function () {
        var dim = f.getAttribute('data-dimension');
        var tag = (f.getAttribute('data-tag') || '').toUpperCase();
        if (!tag) return;
        if (!selections[dim]) selections[dim] = {};
        var pressed = f.getAttribute('aria-pressed') === 'true';
        if (pressed) {
          f.setAttribute('aria-pressed', 'false');
          f.classList.remove('is-selected');
          delete selections[dim][tag];
          if (!Object.keys(selections[dim]).length) delete selections[dim];
        } else {
          f.setAttribute('aria-pressed', 'true');
          f.classList.add('is-selected');
          selections[dim][tag] = true;
        }
        apply();
        updateToggleCount();
      });
    });

    resets.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selections = {};
        brandValue = '';
        folders.forEach(function (f) { f.setAttribute('aria-pressed', 'false'); f.classList.remove('is-selected'); });
        if (brandSelect) brandSelect.value = '';
        apply();
        updateToggleCount();
        setExpanded(false);
        /* scroll to grid */
        var grid = root.querySelector('.gf-grid');
        if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    function showCard(c) {
      if (!c.__hidden) return;
      c.__hidden = false;
      if (c.__t) { clearTimeout(c.__t); c.__t = null; }
      c.style.display = '';
      void c.offsetWidth;            // reflow so the fade-in transitions
      c.classList.remove('is-hidden');
    }
    function hideCard(c) {
      if (c.__hidden) return;
      c.__hidden = true;
      c.classList.add('is-hidden');
      c.__t = setTimeout(function () { if (c.__hidden) c.style.display = 'none'; }, 280);
    }

    function apply() {
      var dims = Object.keys(selections);
      var brandTarget = brandValue ? (prefix + brandValue.toUpperCase()) : '';
      var visible = 0;

      cards.forEach(function (c) {
        var ok = true;
        for (var i = 0; i < dims.length; i++) {            // AND between dimensions
          var tags = Object.keys(selections[dims[i]]);
          var hit = false;
          for (var j = 0; j < tags.length; j++) {          // OR within a dimension
            if (c.__tags.indexOf(tags[j]) !== -1) { hit = true; break; }
          }
          if (!hit) { ok = false; break; }
        }
        if (ok && brandTarget && c.__tags.indexOf(brandTarget) === -1) ok = false;  // AND brand
        if (ok) { visible++; showCard(c); } else { hideCard(c); }
      });

      var anyFilter = dims.length > 0 || !!brandTarget;
      var tpl = anyFilter ? resultsTpl : idleTpl;
      if (countEl) {
        countEl.textContent = tpl
          .replace(/\[count\]/g, visible)
          .replace(/\[files\]/g, visible === 1 ? 'file' : 'files');
      }
      if (emptyEl) emptyEl.hidden = visible !== 0;
    }

    apply(); // set initial counter from live DOM
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.gf-filter').forEach(initGF);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
